import validator from 'validator';

export default class Validation {
  constructor(successCallback, errorCallback) {
    this.successCall = successCallback;
    this.errorCall = errorCallback;
    this.init();
  }

  init() {
    this.forms = Array.prototype.slice.call(document.querySelectorAll('.js-form-validate'));
    this.constraints = {
      email: {
        presence: true,
        email: true
      },
      username: {
        presence: true
      }
    };
    if (!this.forms.length) return;
    this.forms.forEach((form) => {
      form.addEventListener('submit', this.handleFormSubmit.bind(this));
    })
  }

  static isNumeric(value) {
    return /^-?\d+$/.test(value);
  }

  handleFormSubmit(e) {
    e.preventDefault();
    const validFields = [];
    const form = e.target;
    const fields = Array.prototype.slice.call(form.querySelectorAll('.js-field-validate'));

    fields.forEach((field) => {
      // check only visible fields
      if ($(field).is(":hidden")) return;

      if (field.dataset.validationType === 'email') {
        const isValid = validator.isEmail(field.value, this.constraints);
        const isEmpty = validator.isEmpty(field.value, this.constraints);

        if (isEmpty) {
          $(field).closest('label').addClass('is-error is-empty');
        } else {
          $(field).closest('label').removeClass('is-error is-empty');
        }

        validFields.push(isValid);

        if (!isValid) {
          Validation.errorInit(field);
        } else {
          Validation.successInit(field);
        }
      }

      if (field.dataset.validationType === 'empty') {
        const isEmpty = validator.isEmpty(field.value, this.constraints);
        validFields.push(!isEmpty);

        if (isEmpty) {
          Validation.errorInit(field);
        } else {
          Validation.successInit(field);
        }
      }

      if (field.dataset.validationType === 'phone') {
        const lastChar = field.value.charAt(field.value.length - 1);
        const firstChar = field.value.charAt(field.value.length - 14);

        if (!Validation.isNumeric(firstChar)) {
          $(field).closest('label').addClass('is-error is-empty');
        } else {
          $(field).closest('label').removeClass('is-error is-empty');
        }

        const isPhoneFilled = Validation.isNumeric(lastChar);
        validFields.push(isPhoneFilled);


        if (!isPhoneFilled) {
          Validation.errorInit(field);
        } else {
          Validation.successInit(field);
        }
      }


      if (field.tagName.toLowerCase() === 'div' && $(field).hasClass('ss-main')) {
        const selectVal = $(field).siblings('select').val();
        const isFilled = !!selectVal && selectVal !== 'none' && selectVal !== '0' && selectVal !== 0 && selectVal !== undefined;

        validFields.push(isFilled);

        if (!isFilled) {
          Validation.errorInit(field);
        } else {
          Validation.successInit(field);
        }
      }


      if (field.dataset.validationType === 'payment-code') {
        const isPaymentCodeValid = validator.isLength(field.value, { min: 8, max: 8 });
        validFields.push(isPaymentCodeValid);


        if (!isPaymentCodeValid) {
          Validation.errorInit(field);
        } else {
          Validation.successInit(field);
        }
      }


      // password confirm validation
      if (field.className.includes('js-password-confirm')) {
        const isEmptyPass = validator.isEmpty(field.value, this.constraints);

        if (isEmptyPass) {
          $(field).closest('label').addClass('is-error is-empty');
        } else {
          $(field).closest('label').removeClass('is-error is-empty');
        }

        const newPass = $(form).find('.js-new-password').val();
        const isNewPassValid = field.value === newPass;
        validFields.push(isNewPassValid);

        if (!isNewPassValid || isEmptyPass) {
          Validation.errorInit(field);
        } else {
          Validation.successInit(field);
        }
      }
    });


    const allFieldsValid = validFields.every(v => v === true);
    if (allFieldsValid) {
      // run logic on all fields validated (check what logic by attributes, perhaps)
      Validation.onSuccess(e);
      if (this.successCall) this.successCall();
    } else {
      Validation.onError(e);
      if (this.errorCall) this.errorCall();
    }
  }

  static errorInit(field) {

    if ($(field).hasClass('ss-main')) $(field).addClass('is-error');
    const $wrapper = $(field).parents('label');
    const $wrapperMain = $(field).parents('.js-field-validate-wrap');

    $wrapper.addClass('is-error');
    $wrapperMain.addClass('is-error');
  }

  static successInit(field) {
    if ($(field).hasClass('ss-main')) $(field).removeClass('is-error');
    const $wrapper = $(field).parents('label');
    const $wrapperMain = $(field).parents('.js-field-validate-wrap');

    $wrapper.removeClass('is-error');
    $wrapperMain.removeClass('is-error');
  }

  static onError(e) {
    const form = e.target;
    form.classList.remove('is-validated');
  }

  static onSuccess(e) {
    const form = e.target;
    const { formName } = form.dataset;
    form.classList.add('is-validated');

    if ($(form).hasClass('js-validate-callback')) return;

    $(`[data-form-success=${formName}]`).show();
  }
}
